import "./App.css";
import Footer from "./layout/Footer/Footer";
import Header from "./layout/Header/Header";

function App() {
  return (
    <div className="w-full bg-primary-irisBlue">
      <Header />
      <Footer />
    </div>
  );
}

export default App;
